<template>
  <div>
    <header-row :page="page"/>
    <section class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 bg-white transform sm:-translate-y-11 p-4 pt-10 sm:p-16 sm:pt-24 md:p-32 md:pb-24">
      <div v-for="(addOn, index) in addOns" :key="index" class="mb-6 sm:mb-160 relative flex flex-col">
        <img
          v-if="addOn.image"
          :src="addOn.image.url"
          :alt="addOn.title"
          aria-hidden="true"
          class="w-full"
        >
        <div class="absolute top-0 right-0 bg-primary text-white text-xs px-4 py-1 font-bold">
          {{ addOn.type }}
        </div>
        <div class="flex justify-between bg-primary px-4 py-2 text-white font-bold">
          <div>
            {{ addOn.title }}
          </div>
          <div class="text-secondary whitespace-no-wrap">
            € {{ addOn.price }}
          </div>
        </div>
        <div class="bg-background px-8 py-3 content flex-grow leading-relaxed" v-html="addOn.text"/>
      </div>
    </section>
    <configuration-row :page="page"/>
  </div>
</template>

<script>
import page from '~/plugins/mixins/page.js';
import addOnsQuery from '~/graphql/queries/add-ons.gql';
import HeaderRow from '~/components/stijlen/HeaderRow';
import ConfigurationRow from '~/components/ConfigurationRow';

export default {
  components: {
    HeaderRow,
    ConfigurationRow,
  },
  mixins: [page],
  apollo: {
    addOns: {
      query: addOnsQuery,
    },
  },
};
</script>

<style>
  .content ul {
    @apply list-disc;
  }
</style>
